var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 92,
    viewBox: "0 0 91 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6104 57.1582C59.552 57.1582 57.7104 57.9707 56.302 59.2437L36.9916 48.0041C37.127 47.3812 37.2354 46.7582 37.2354 46.1082C37.2354 45.4582 37.127 44.8353 36.9916 44.2124L56.0854 33.0812C57.5479 34.4353 59.4708 35.2749 61.6104 35.2749C66.1062 35.2749 69.7354 31.6457 69.7354 27.1499C69.7354 22.6541 66.1062 19.0249 61.6104 19.0249C57.1145 19.0249 53.4854 22.6541 53.4854 27.1499C53.4854 27.7999 53.5937 28.4228 53.7291 29.0457L34.6354 40.177C33.1729 38.8228 31.2499 37.9832 29.1104 37.9832C24.6145 37.9832 20.9854 41.6124 20.9854 46.1082C20.9854 50.6041 24.6145 54.2332 29.1104 54.2332C31.2499 54.2332 33.1729 53.3937 34.6354 52.0395L53.9187 63.3062C53.7833 63.8749 53.702 64.4707 53.702 65.0666C53.702 69.427 57.2499 72.9749 61.6104 72.9749C65.9708 72.9749 69.5187 69.427 69.5187 65.0666C69.5187 60.7062 65.9708 57.1582 61.6104 57.1582Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4283",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 19,
    width: 50,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6104 57.1582C59.552 57.1582 57.7104 57.9707 56.302 59.2437L36.9916 48.0041C37.127 47.3812 37.2354 46.7582 37.2354 46.1082C37.2354 45.4582 37.127 44.8353 36.9916 44.2124L56.0854 33.0812C57.5479 34.4353 59.4708 35.2749 61.6104 35.2749C66.1062 35.2749 69.7354 31.6457 69.7354 27.1499C69.7354 22.6541 66.1062 19.0249 61.6104 19.0249C57.1145 19.0249 53.4854 22.6541 53.4854 27.1499C53.4854 27.7999 53.5937 28.4228 53.7291 29.0457L34.6354 40.177C33.1729 38.8228 31.2499 37.9832 29.1104 37.9832C24.6145 37.9832 20.9854 41.6124 20.9854 46.1082C20.9854 50.6041 24.6145 54.2332 29.1104 54.2332C31.2499 54.2332 33.1729 53.3937 34.6354 52.0395L53.9187 63.3062C53.7833 63.8749 53.702 64.4707 53.702 65.0666C53.702 69.427 57.2499 72.9749 61.6104 72.9749C65.9708 72.9749 69.5187 69.427 69.5187 65.0666C69.5187 60.7062 65.9708 57.1582 61.6104 57.1582Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4283)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d534f47d86acdc344f60f6b44af1eb83.svg";
export { ForwardRef as ReactComponent };